import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '../baseQueries/axiosBaseQuery';
import { CONFIG } from '../../constants';

const companySizeUrl = '/api/company-size';

interface ApiResponse<T = unknown> {
  status: boolean;
  statusCode: number | null;
  data?: T;
  message?: string | string[] | null;
}

export const crmApi = createApi({
  reducerPath: 'crmApi',
  baseQuery: axiosBaseQuery({ baseUrl: CONFIG.API_CRM_URL || '' }),
  tagTypes: ['CompanySize'],
  endpoints: builder => ({
    getClientSources: builder.query({
      query: () => ({ url: '/api/opportunity/source' }),
      transformResponse: (response: unknown) => response || [],
    }),
    getCompanySizes: builder.query({
      query: search => ({
        url: companySizeUrl,
        params: { search },
      }),
      providesTags: ['CompanySize'],
      transformResponse: (response: ApiResponse) => response.data || [],
    }),
    createCompanySize: builder.mutation({
      query: payload => ({
        url: companySizeUrl,
        method: 'POST',
        data: payload,
      }),
      invalidatesTags: ['CompanySize'],
    }),
    updateOpportunityStatus: builder.mutation({
      query: ({ customerId, opportunityId, payload }) => ({
        url: `/api/${customerId}/opportunity/${opportunityId}`,
        method: 'PATCH',
        data: payload,
      }),
    }),
  }),
});

export const {
  useGetClientSourcesQuery,
  useGetCompanySizesQuery,
  useCreateCompanySizeMutation,
  useUpdateOpportunityStatusMutation,
} = crmApi;
